(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    const paymentTermsStyleId = 'kada-payment-terms-presentation';

  const stylePaymentTerms = (element) => {
    if (!(element instanceof HTMLElement) || !element.closest('.kada-product-header')) return;

    customElements.whenDefined('shopify-payment-terms').then(() => {
      let attempts = 0;

      const connect = () => {
        const shadowRoot = element.shadowRoot;
        if (!shadowRoot) {
          attempts += 1;
          if (attempts < 30) requestAnimationFrame(connect);
          return;
        }

        if (shadowRoot.getElementById(paymentTermsStyleId)) return;

        const style = document.createElement('style');
        style.id = paymentTermsStyleId;
        style.textContent = `
          :host,
          #shopify-installments-content {
            color: var(--kada-ph-payment-color, currentColor) !important;
            font-size: inherit !important;
            line-height: inherit !important;
          }

          #shopify-installments-content .font-bold {
            color: var(--kada-ph-payment-amount-color, currentColor) !important;
            font-weight: var(--kada-ph-payment-amount-weight, 650) !important;
          }
        `;
        shadowRoot.append(style);
      };

      connect();
    });
  };

  const scanPaymentTerms = (root) => {
    if (root instanceof Element && root.matches('shopify-payment-terms')) stylePaymentTerms(root);
    root.querySelectorAll?.('shopify-payment-terms').forEach(stylePaymentTerms);
  };

  scanPaymentTerms(document);

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) scanPaymentTerms(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
